import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// ADMIN
// ═══════════════════════════════════════════════════════════════════════════
export const ADMIN_ROUTES: RouteEntry[] = [
  {
    path: 'admin',
    component: 'AdminDashboardPage',
    label: 'Admin Dashboard',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/countries',
    component: 'CountriesPage',
    label: 'Countries',
    allowedRoles: ['super_admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/countries/:countryId',
    component: 'CountryDetailPage',
    label: '',
    allowedRoles: ['super_admin'],
    navSection: 'Admin',
    hideFromNav: true,
  },
  {
    path: 'admin/country-business-classes',
    component: 'CountryBusinessClassesPage',
    label: 'Country Business Classes',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/companies',
    component: 'CompaniesPage',
    label: 'Companies',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/users',
    component: 'UsersPage',
    label: 'Users',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/yield-curves',
    component: 'AdminYieldCurvesPage',
    label: 'Yield Curves',
    allowedRoles: ['super_admin', 'admin', 'consultant_user'],
    navSection: 'Admin',
    // Also appears in actuarial_model > Global Assumptions nav
  },
  {
    path: 'admin/mortality-tables',
    component: 'AdminMortalityTablesPage',
    label: 'Mortality Tables',
    allowedRoles: ['super_admin', 'admin', 'consultant_user'],
    navSection: 'Admin',
    // Also appears in actuarial_model > Global Assumptions nav
  },
  {
    path: 'admin/reinsurers',
    component: 'AdminReinsurersPage',
    label: 'Reinsurers',
    allowedRoles: ['super_admin', 'admin', 'consultant_user', 'company_user'],
    navSection: 'Admin',
  },
  {
    path: 'admin/commission-signatures',
    component: 'AdminCommissionSignaturesPage',
    label: 'Commission Signatures',
    allowedRoles: ['super_admin', 'admin', 'consultant_user'],
    navSection: 'Admin',
  },
  {
    path: 'admin/feature-flags',
    component: 'FeatureFlagsPage',
    label: 'Feature Flags',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/scheduled-reports',
    component: 'ScheduledReportsPage',
    label: 'Scheduled Reports',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'admin/job-dashboard',
    component: 'JobDashboardPage',
    label: 'Job Dashboard',
    allowedRoles: ['super_admin', 'admin'],
    navSection: 'Admin',
  },
  {
    path: 'integration-settings',
    component: 'IntegrationSettingsPage',
    label: 'Integration Settings',
    allowedRoles: [], // no ProtectedRoute wrapper
    navSection: 'Admin',
    hideFromNav: true,
    // MISMATCH: route exists but no nav item; no role guard
  },
  {
    path: 'system-metrics',
    component: 'SystemMetricsPage',
    label: 'System Metrics',
    allowedRoles: [], // no ProtectedRoute wrapper
    navSection: 'Admin',
    hideFromNav: true,
    // MISMATCH: route exists but no nav item; no role guard
  },
  {
    path: 'admin/system-limits',
    component: 'SystemLimitsPage',
    label: 'System Limits',
    allowedRoles: [], // no ProtectedRoute wrapper
    navSection: 'Admin',
    hideFromNav: true,
    // MISMATCH: route exists but no nav item; no role guard
  },
];
